module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_07-84c5d67b1f2e5385f8bf6aa6f9b0451d.svg";